import React, { useEffect } from 'react';
import BaseSelect from 'components/common/BaseSelect/BaseSelect';
import { useDispatch, useSelector } from 'react-redux';
import { setActionReasons } from '../../../../../../actions/tools/OrdersSearchActions';
import { getActionReasons } from '../../../../../../extractFromState';
import { SelectHolder } from './SelectInputReason.styles';

const SelectInputReason = ({ placeholder = '', options, fields }) => {
  const dispatch = useDispatch();

  const actionReasons = useSelector(getActionReasons);

  const handleUpdateFields = (value, field) => {
    const updatedActionReasons = Object.assign({}, actionReasons || {}, { [field]: value });
    dispatch(setActionReasons(updatedActionReasons));
  };

  useEffect(() => {
    dispatch(setActionReasons(null));
  }, [dispatch]);

  return (
    <SelectHolder>
      <BaseSelect
        defaultSelect={false}
        isClearable
        placeholder={placeholder}
        options={options}
        onChange={(selectedOption) => {
          const value = selectedOption ? selectedOption.value : null;
          handleUpdateFields(value, fields.primaryReason);
        }}
      />
    </SelectHolder>
  );
};

export default SelectInputReason;
